






























import { Component, Vue } from "vue-property-decorator";
import Header from "@/components/header/OHeader.vue";
import Footer from "@/components/Footer.vue";

@Component({
  components: {
    Header,
    Footer,
  },
})
export default class OResetPassEmail extends Vue {}
